import { useState } from "react";
import { separateWords, capitalizeWord, acronymTransformer, replaceUnderscore } from "../Utils/contentTransformers";

function formatFieldName(fieldName) {
    let fieldNameWordsArray = separateWords(fieldName);
    fieldNameWordsArray = fieldNameWordsArray.map(fieldNameWord => capitalizeWord(fieldNameWord));
    fieldNameWordsArray = fieldNameWordsArray.map(fieldNameWord => acronymTransformer(fieldNameWord));
    fieldNameWordsArray = fieldNameWordsArray.join(" ");
    return fieldNameWordsArray;
}

function formatListTitle(fieldName) {
    let fieldNameWordsArray = separateWords(fieldName);
    fieldNameWordsArray = fieldNameWordsArray.map(fieldNameWord => fieldNameWord.toUpperCase());
    fieldNameWordsArray = fieldNameWordsArray.join(" ");
    return fieldNameWordsArray;
}

function getBusinessName(overviewList, index) {
    let baseType = Object.keys(overviewList[index].referenceData);

    switch(baseType[0]) {
        case "instrument":
            return overviewList[index].referenceData.instrument.instrumentShortName;
        case "entity":
            return overviewList[index].referenceData.entity.entityLongName;
        case "listing":
            return overviewList[index].lookup.listingShortName;
        case "market":
            return overviewList[index].referenceData.market.marketShortName;
        case "listingSymbology":
            return overviewList[index].lookup.listingShortName;
        case "instrumentSymbology":
            return overviewList[index].lookup.instrumentShortName;
    }
}

function getBusinessType(overviewList, index) {
    let baseType = Object.keys(overviewList[index].referenceData);

    switch(baseType[0]) {
        case "instrument":
            return overviewList[index].referenceData.instrument.instrumentType;
        case "entity":
            return overviewList[index].referenceData.entity.entityType;
        case "listing":
            return overviewList[index].lookup.marketShortName;
        case "market":
            return overviewList[index].referenceData.market.marketType;
        case "listingSymbology":
            return overviewList[index].lookup.marketShortName;
        case "instrumentSymbology":
            return overviewList[index].lookup.instrumentType;
    }
}

function getBusinessField(overviewList, index) {
    let baseType = Object.keys(overviewList[index].referenceData);

    switch(baseType[0]) {
        case "instrument":
            return overviewList[index].referenceData.instrument;
        case "entity":
            return overviewList[index].referenceData.entity;
        case "listing":
            return overviewList[index].referenceData.listing;
        case "market":
            return overviewList[index].referenceData.market;
        case "listingSymbology":
            return overviewList[index].referenceData.listingSymbology;
        case "instrumentSymbology":
            return overviewList[index].referenceData.instrumentSymbology;
    }
}

const MainList = (props) => {
    let mainList;
    let baseType = Object.keys(props.overviewList[props.activeFieldSet].referenceData);
    let overviewList = getBusinessField(props.overviewList, props.activeFieldSet);

    mainList = Object.keys(overviewList).map(key => {
        if (typeof overviewList[key] === 'string') {
            return (
                <div className="overview-list-item">
                    <p className="field-name">{formatFieldName(key)}</p>
                    <p className="field-value">{replaceUnderscore(overviewList[key])}</p>
                </div>
            )
        }
    })

    return (
        <div className="main-overview-list">
            <h5 className="list-title">{formatListTitle(baseType[0])}</h5>
            {mainList}
        </div>
    );
}

const InnerList = (props) => {
    let innerLists;
    let overviewList = getBusinessField(props.overviewList, props.activeFieldSet);

    innerLists = Object.keys(overviewList).map(key => {
        if (typeof overviewList[key] === 'object') {
            let innerList;

            innerList = Object.keys(overviewList[key]).map(innerKey => {
                return (
                    <div className="overview-list-item">
                        <p className="field-name">{formatFieldName(innerKey)}</p>
                        <p className="field-value">{overviewList[key][innerKey]}</p>
                    </div>
                )
            })

            return (
                <div className="inner-overview-list">
                    <h5 className="list-title">{formatListTitle(key)}</h5>
                    {innerList}
                </div>
            );
        }
    });

    return (
        <div className="inner-overview-lists">
            {innerLists}
        </div>
    );
}

const APIOverviewExample = ({apiInfo}) => {
    let overviewList = apiInfo.example;
    let [activeFieldSet, setActiveFieldSet] = useState(0);

    return (
        <>
            <div className="example-buttons">
                {
                    overviewList.map((business, index) => {
                        return (
                            <button
                                className={"example-button " + (index === activeFieldSet ? "example-button--active" : "")}
                                onClick={() => {
                                    setActiveFieldSet(index);
                                }}>
                                <p className="name">{getBusinessName(overviewList, index)}</p>
                            </button>
                        )}
                    )
                }
            </div>
            <div className="example-content">
                <div className="instrument-name">
                    <h2 className="overview-example-name">{getBusinessName(overviewList, activeFieldSet)}</h2>
                    <h3 className="overview-example-type">{replaceUnderscore(getBusinessType(overviewList, activeFieldSet))}</h3>
                </div>
                <div className="overview-lists">
                    <MainList activeFieldSet={activeFieldSet} overviewList={overviewList} />
                    <InnerList activeFieldSet={activeFieldSet} overviewList={overviewList} />
                </div>
            </div>
        </>
    )
};

export default APIOverviewExample;